<dx-popup class="popup" [width]="620" [height]="300" [showTitle]="true" title="Update Patient"
          [dragEnabled]="true"
          [closeOnOutsideClick]="false"
          [showCloseButton]="false"
          [(visible)]="popupVisible">

  <dxi-toolbar-item location="after">
    <dx-button text="Close" (click)="close()"></dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item location="after">
    <dx-button text="Save" (click)="save()" [disabled]="clientPhysicianDialogForm.invalid"></dx-button>
  </dxi-toolbar-item>


  <div *dxTemplate="let data of 'content'" style="height: 100%">
    <form [formGroup]="clientPhysicianDialogForm" style="height: 100%">
      <div class="padding-block" fxLayout="column" fxLayoutAlign="space-between"
           style="padding-bottom: 16px !important;">
        <div fxLayout="row" *ngIf="subtitle && subtitle !== ''">
          <p style="color: red">{{subtitle}}</p>
        </div>
        <div fxLayout="row" fxLayoutGap="12px">
          <app-client-selector style="width: 374px !important;"
                               [control]="convertToFormControl(clientPhysicianDialogForm.get('client'))"
                               [required]="true"></app-client-selector>
          <app-physician-selector style="width: 180px!important;" [label]="'Primary Physician'" [buttonMode]="false"
                                  [control]="convertToFormControl(clientPhysicianDialogForm.get('physician'))"></app-physician-selector>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between">
          <div>
            <app-selector
              [items]="units.value"
              [label]="'Unit'"
              [control]="convertToFormControl(clientPhysicianDialogForm.get('unit'))"
              [displayExpr]="'name'"
              [keyExpr]="'id'"
              [required]="false"
              [validationGroup]="'patient'">
            </app-selector>
           <!-- <app-unit-selector
              [units]="units.value"
              [displayExpr]="'name'"
              [control]="convertToFormControl(clientPhysicianDialogForm.get('unit'))"
              [required]="false"
              [validationGroup]="'patient'">
            </app-unit-selector>-->
          </div>
          <div>
            <app-selector
              [items]="selectRooms.value"
              [label]="'Room'"
              [control]="convertToFormControl(clientPhysicianDialogForm.get('room'))"
              [displayExpr]="'name'"
              [keyExpr]="'id'"
              [required]="false"
              [validationGroup]="'patient'">
            </app-selector>
          </div>
          <div>
            <div class="dx-field">
              <div class="dx-field-label">Bed</div>
              <div class="dx-field-value">
                <dx-text-box class="uppercase" [inputAttr]="{autocomplete: 'new-bed'}"
                             [formControl]="convertToFormControl(clientPhysicianDialogForm.get('bed'))"></dx-text-box>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</dx-popup>
